import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { useAuth } from "../../authentication/AuthProvider";
import { MainContainer } from "../../components/container/MainContainer";
import { PageTitleContainer } from "../../components/container/PageTitleContainer";
import ThirdTabs from "../../components/tabs/ThirdTabs";
import { DPP } from "../../db_access/dpp";
import muiSytle from "../../style/components-style/muiStyle";
import DPP_List from "./DPP_List";
const DPP_Dashboard = () => {
  const { t } = useTranslation();
  const mine = { label: "Mine", value: "Mine" };
  const colleague = { label: "Colleague", value: "Colleague" };
  let tabs = [mine];
  const subTabs = [
    { label: "Published", value: "Published" },
    { label: "Pending", value: "Pending" },
  ];
  const [selectedTab, setSelectedTab] = useState("Mine");
  const [selectedSubTab, setSelectedSubTab] = useState("Published");
  const { user } = useAuth();
  const is_Mine = () => selectedTab === tabs[0]?.value;
  const is_Colleague = () => selectedTab === tabs[1]?.value;
  const is_Published = () => selectedSubTab === subTabs[0].value;
  const is_Pending = () => selectedSubTab === subTabs[1].value;
  const is_CAdmin = () => user["is_company_admin"] === 1;
  if (is_CAdmin()) {
    tabs.push(colleague);
  }
  return (
    <MainContainer>
      <PageTitleContainer>
        <Box>
          <Box>
            <Typography variant="Page Title">{t("Digital Product Passports Dashboard")}</Typography>
          </Box>
          <Box>
            <Typography variant="Page Subtitle">{t("Understanding DPP benefits and managing published passports")}</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 0.5,
            backgroundColor: "rgba(23, 163, 74, 0.2)",
            marginTop: 0.4,
            marginBottom: "auto",
            paddingLeft: 1,
            paddingRight: 1.5,
            paddingY: 0.5,
            borderRadius: 4,
            alignItems: "center",
          }}>
          <IoMdCheckmarkCircleOutline color="#166534" size={20} />
          <Typography sx={{ fontFamily: "Poppins", color: "#166534", paddingTop: 0.1 }}>{t("EU Regulation Compliant")}</Typography>
        </Box>
      </PageTitleContainer>
      <Box sx={{ paddingY: 1 }}>
        <Box sx={{ display: tabs.length > 1 ? "block" : "none" }}>
          <ThirdTabs selected={selectedTab} setSelected={setSelectedTab} options={tabs} />
        </Box>
        <Box>
          <ThirdTabs selected={selectedSubTab} setSelected={setSelectedSubTab} options={subTabs} />
        </Box>
      </Box>
      <Box sx={{ display: is_Colleague() && is_Published() ? "block" : "none" }}>
        <DPP_List
          title={"Published Colleague Digital Product Passports"}
          subtitle={"Manage and view all published DPPs from the DPP Features module"}
          getPassports={DPP.get_mine_colleague_published}
          pending={false}
          edit={is_CAdmin()}
        />
      </Box>
      <Box sx={{ display: is_Mine() && is_Published() ? "block" : "none" }}>
        <DPP_List
          title={"Published Mine Digital Product Passports"}
          subtitle={"Manage and view all published DPPs from the DPP Features module"}
          getPassports={DPP.get_mine_published}
          pending={false}
        />
      </Box>
      <Box sx={{ display: is_Colleague() && is_Pending() ? "block" : "none" }}>
        <DPP_List
          title={"Pending Colleague Digital Product Passports"}
          subtitle={"Manage and view all published DPPs from the DPP Features module"}
          getPassports={DPP.get_mine_colleague_pending}
          published={false}
          history={false}
          edit={is_CAdmin()}
        />
      </Box>
      <Box sx={{ display: is_Mine() && is_Pending() ? "block" : "none" }}>
        <DPP_List
          title={"Pending Mine Digital Product Passports"}
          subtitle={"Manage and view all published DPPs from the DPP Features module"}
          getPassports={DPP.get_mine_pending}
          published={false}
          history={false}
        />
      </Box>
    </MainContainer>
  );
};
export default DPP_Dashboard;
